import { gql } from '@apollo/client'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Table, Alert } from 'reactstrap'
import { PROCESS_TIMEKEEPER_FILE_QUERY } from '../../../graphql'
import { FileUploadForm } from '../FileUploadForm'
import './timekeeper.css'
import { getData } from '../CustomUtils'
import FormHeading from '../FormHeading'

export const PROCESS_TIMEKEEPER_FILE = gql(PROCESS_TIMEKEEPER_FILE_QUERY)

export default function UploadTimekeeperFile() {
  console.log('UploadTimekeeperFile rendered')

  const navigate = useNavigate()
  const [timeKeeperInfo, setTimekeeperInfo] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function processFile(fileName) {
    getData(null, PROCESS_TIMEKEEPER_FILE, 'processTimekeeperFile', setTimekeeperInfo, setGraphQLErrors, 'fileName', fileName)
    console.log('UploadTimekeeperFile.processFile')
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (timeKeeperInfo) {
    let resultRows = []
    for (let i = 0; i < timeKeeperInfo.length; i++) {
      let row = []
      row.push(<td key={timeKeeperInfo[i].value}>{timeKeeperInfo[i].value}</td>)
      row.push(<td key={timeKeeperInfo[i].label}>{timeKeeperInfo[i].label}</td>)
      resultRows.push(<tr key={i}>{row}</tr>)
    }
    return (
      <div className="custom-scroll timekeeper-table" >
        <form className="form">
          <div>
            <Table bordered>
              <FormHeading headingText='Timekeeper Update Info' />
              <tbody>
                {resultRows}
              </tbody>
            </Table>
          </div>
          <div className="custom-button-container">
            <Button color="primary" onClick={() => navigate('/home')}>Ok</Button>
          </div>
        </form>
      </div>
    )
  }
  return <FileUploadForm setFileName={processFile} />
}